import { createElementBlock, createElementVNode, openBlock, renderSlot, toDisplayString } from "vue";
//#region src/components/code_editor/code_editor_tag.vue
var _hoisted_1 = { class: "dtc-scheme__identifier" };
var _sfc_main = /* @__PURE__ */ Object.assign({ name: "DtcCodeEditorTag" }, {
	props: { name: {
		type: String,
		required: true
	} },
	setup(__props) {
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", null, [
				_cache[0] || (_cache[0] = createElementVNode("span", null, "<", -1)),
				renderSlot(_ctx.$slots, "start"),
				createElementVNode("span", _hoisted_1, toDisplayString(__props.name), 1),
				renderSlot(_ctx.$slots, "end"),
				_cache[1] || (_cache[1] = createElementVNode("span", null, ">", -1))
			]);
		};
	}
});
//#endregion
export { _sfc_main as default };

//# sourceMappingURL=code_editor_tag.vue.js.map